import React from "react";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Growl } from "primereact/growl";
import servicioHttp from "../servicio/ServicioHttp";
import ServicioObjetos from '../servicio/ServicioObjetos';
import { Message } from "primereact/message";
import servicioAsignacionValoresObjetos from "../servicio/ServicioObjetos";
import servicioFormatos from '../servicio/ServicioFormatos';
import { Dropdown } from "primereact/dropdown";
import { CALENDARIO_ES_MX, FORMATO_FECHA_CALENDAR } from '../servicio/ServicioConstantes';


export class Bitacora extends React.Component {


    constructor() {
        super();
        this.state = {
            fecha: {},
            errores: {},
            paginacion: { registrosPorPagina: 20 },
            usuario: null,
            id: null,
            movimientos: [
                { label: "Alta", value: "Alta" },
                { label: "Modificación", value: "Modificación" },
                { label: "Eliminación", value: "Eliminación" }
            ],
            movimiento: null
        };
    }

    buscarPorFechas = () => {
        let { fecha, movimiento } = this.state;
        const validacion = this.validarFechas(fecha, movimiento);
        this.setState({ errores: validacion });
        if (!Object.keys(validacion).length) {
            fecha.movimiento = movimiento;
            servicioHttp
                .consumirPostHttp("bitacora/consultar_bitacora_fechas.json", fecha)
                .then((response) => {
                    this.setState({ paginacion: response.data.objeto });
                    this.growl.show({
                        severity: response.data.error === false ? "success" : "error",
                        summary: "",
                        detail: response.data.mensaje,
                    });
                })
                .catch(() => { });
        }
    }

    validarFechas = (objeto, movimiento) => {
        const errores = {};
        if (ServicioObjetos.esObjetoVacio(objeto.fechaInicial))
            errores.fechaInicial = "Ingrese la Fecha Inicial";
        if (ServicioObjetos.esObjetoVacio(objeto.fechaFinal))
            errores.fechaFinal = "Ingrese la Fecha Final";
        if (ServicioObjetos.esObjetoVacio(movimiento))
            errores.movimiento = "Seleccione movimiento";
        return errores;
    };

    asignarValores = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, false);
    };

    columnaFecha = (rowData, column) => {
        return <div>{servicioFormatos.formatearFecha(rowData.fechaMovimiento)}</div>;
    }

    render() {
        let { fecha, errores, paginacion } = this.state;        

        return (

            <div className="p-grid">
                <Growl ref={(el) => (this.growl = el)} />
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <h1>Bitácora</h1>

                        <div className="p-fluid p-grid">

                            <div className="p-col-12 p-md-12">
                                <label></label>
                            </div>

                            <div className="p-col-12 p-md-3">
                                <h4>*Movimiento:</h4>
                                <Dropdown options={this.state.movimientos} value={this.state.movimiento} onChange={(event) => this.setState({ movimiento: event.value })} />
                                {errores.movimiento ? (<div><br /> <Message severity="error" text={errores.movimiento} />{" "}</div>) : null}
                            </div>
                            <div className="p-col-12 p-md-3">
                                <h4>*Fecha Inicial:</h4>
                                <Calendar id="fechaInicial" name="fecha.fechaInicial" value={fecha.fechaInicial} onTodayButtonClick={true} onChange={(e) => { this.asignarValores(e, false) }} className={errores.fechaInicial ? 'p-error' : ''} dateFormat={FORMATO_FECHA_CALENDAR} locale={CALENDARIO_ES_MX}/>
                                {errores.fechaInicial ? <div><br /> <Message severity="error" text={errores.fechaInicial} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-3">
                                <h4>*Fecha Final:</h4>
                                <Calendar id="fechaFinal" name="fecha.fechaFinal" value={fecha.fechaFinal || ''} onChange={(e) => { this.asignarValores(e, false) }} className={errores.fechaFinal ? 'p-error' : ''} dateFormat={FORMATO_FECHA_CALENDAR} locale={CALENDARIO_ES_MX}/>
                                {errores.fechaFinal ? <div><br /> <Message severity="error" text={errores.fechaFinal} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-3">
                                <br /><br /><br />
                                <Button label="Buscar" icon="pi-md-search" onClick={this.buscarPorFechas.bind(this)} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="p-col-12">
                    <div className="card card-w-title">
                        <DataTable value={paginacion.datos} editable={true} selectionMode="single" responsive={true} header="Bitácora" paginator={true} rows={20} >
                            <Column field="nombreUsuario" header="Usuario" autoLayout={true} />
                            <Column field="movimiento" header="Movimiento" autoLayout={true} />
                            <Column field="descripcion" header="Descripción" autoLayout={true} />
                            <Column body={this.columnaFecha} header="Fecha de Movimiento" autoLayout={true} />
                        </DataTable>
                    </div>
                </div>

            </div>
        );
    }
}